module.exports = __webpack_public_path__ + "static/media/headshot.0177c123.jpeg";